import React from "react";
import TimeSavingAutomation from "../iamges/Time-Saving-Automation.png";
import CanadianLegalCompliance from "../iamges/Canadian-Legal-Compliance.png";
import LocalServiceNetwork from "../iamges/Local-Service-Network.png";
import HomeOwnerAIAssistant from "../iamges/HomeOwner-AI-Assistant.png";
import ImportantTasks from "../iamges/Important-tasks.png";
import BuyingAndSellingHomeGuidance from "../iamges/Buying-and-Selling-Home-Guidance.png";

const benefits = [
  {
    title: "Time‑Saving Automation",
    desc: "Intelligent reminders and workflows reduce manual tracking for rent, tenants, and maintenance.",
    img: TimeSavingAutomation,
  },
  {
    title: "Canadian Legal Compliance",
    desc: "Province-specific landlord-tenant laws and rental regulations built  into every feature.",
    img: CanadianLegalCompliance,
  },
  {
    title: "Local Service Network",
    desc: "Trusted, vetted professionals in your area whenever your rental property needs help.",
    img: LocalServiceNetwork,
  },
  {
    title: "HomeOwner AI Assistant",
    desc: "Ask anything—from ‘what documents do I need to sell my house?’ The AI assistant guides you step‑by‑step.",
    img: HomeOwnerAIAssistant,
  },
  {
    title: "Move‑In & Move‑Out Checklists",
    desc: "Follow curated checklists when moving homes—from utility transfers to inventory packing—ensuring nothing gets missed.",
    img: ImportantTasks,
  },
  {
    title: "Buying and Selling Home Guidance",
    desc: "Access step‑by‑step guides, legal checklists, and expert tips tailored to Canadian homeowners.",
    img: BuyingAndSellingHomeGuidance,
  },
];

export default function BenefitsSection() {
  return (
    <section className='max-w-7xl mx-auto px-6 md:px-10 py-16'>
      <header className='text-center mb-12'>
        <h2 className='text-3xl md:text-5xl font-extrabold text-gray-900'>
          Our Benefits
        </h2>
        <p className='mt-3 text-base md:text-lg text-gray-500'>
          Free to use. No account unlock required.
        </p>
      </header>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {benefits.map((b, idx) => (
          <div
            key={idx}
            className='bg-[#A5D7261A] rounded-[20px] flex flex-col justify-between hover:shadow-md transition-shadow'>
            <div className='p-6'>
              <h3 className='text-[28px] font-bold text-gray-900 mb-2 uppercase tracking-wide'>
                {b.title}
              </h3>
              <p
                className='text-[16px] leading-6 mb-0'
                style={{ color: "#000000A3" }}>
                {b.desc}
              </p>
            </div>

            {/* Placeholder for image slot */}
            <img
              src={b.img}
              alt={b.title}
              className='w-[80%] h-auto ml-auto rounded-b-[20px]'
            />
          </div>
        ))}
      </div>
    </section>
  );
}
